<template>
  <div class="hjyxpjf">


    <div class="calc-templete">
      <h6>环境影响评价费计算模版</h6>
      <t-form :data="formData" :rules="rules" ref="form" @reset="onReset" @submit="onSubmit" labelWidth="195px">
        <t-row style="height: auto;align-items: stretch;">
          <t-col :span="6"
            style="border-right: 1px solid #DADDE1;padding-left: 40px;padding-right: 140px;padding-bottom: 50px;height: auto;">
            <div class="left-top-title"><span>编制环境影响报告表</span></div>
            <t-form-item label="计算依据">
              <a class="file-name" v-if="fileList" @click="fileOpenDialog(fileList.url)">{{fileList.fileName }}</a>
              <a v-else class="no-file-name">无文件</a>
             
            </t-form-item>
            <t-form-item label="工程名称" name="projectName">

              <t-input v-model="formData.projectName" placeholder="请输入工程名称"></t-input>

            </t-form-item>
            <t-form-item label="估算投资额" name="money">
              <!-- <t-input v-model="formData.money" v-digits @keyup="validateInput" placeholder="请输入工程造价"  style="width: 320px;" suffix="万元（中标价）"></t-input> -->
              <t-input-number v-model="formData.money" placeholder="请输入估算投资额" suffix="亿元（中标价）" type="number" :min="0" theme="normal"></t-input-number>
            </t-form-item>

            <t-form-item name="industryCoefficient" label="专业调整" class="form-item-left">
              <t-input v-model="formData.industryCoefficient" placeholder="请选择行业调整系数"></t-input>


              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible1">系数说明
                <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>
            <t-form-item name="circumstancesCoefficient" label="环境敏感程度调整" class="form-item-left">
              <t-input-number v-model="formData.circumstancesCoefficient" placeholder="请选择环境敏感程度调整系数" type="number" :min="0" theme="normal"></t-input-number>
              <t-button theme="default" variant="outline" class="coefficient" @click="openVisible2">系数说明
                <img src="@/assets/icon/Vector.svg" style="width: 4px;height: 7px;left: 4px;top: 8px;position: relative;">
              </t-button>
            </t-form-item>
           
            <t-form-item label="浮动率" name="floatingRate">
              <t-input-number v-model="floatingRate" placeholder="" suffix="%" :min="0" :max="100" theme="normal"></t-input-number>
            </t-form-item>
            <t-form-item label="让利利率" name="discountRate">
              <t-input-number v-model="discountRate" placeholder="" label="-" suffix="%" :min="0" :max="100" theme="normal"/>

            </t-form-item>
            <t-button theme="primary" type="submit" class="submit">提交结果</t-button>
          </t-col>
          <t-col :span="6" style="padding-left: 106px;padding-right: 70px;padding-bottom: 50px;">
            <div class="right-top-title"><span>计算结果</span></div>
            <t-form-item name="subtotal" class="form-item-left">
              <span slot="label">
                <!-- <img src="@/assets/icon/icon1.svg" class="form-itme-icon"> -->
                环评费基价
              </span>
              <t-input v-model="formData.subtotal" placeholder="" disabled suffix="元"></t-input>

            </t-form-item>
            <t-form-item label="计算过程">
              <t-textarea v-model="jsgc" placeholder="" disabled :autosize="{ minRows: 3, maxRows: 5 }"></t-textarea>
            </t-form-item>
            <t-form-item label="折后环评费" name="result">
              <t-input v-model="formData.result" placeholder="" disabled suffix="元" @change="resultChange"></t-input>
            </t-form-item>
            <t-form-item label="金额大写" name="resultChinese">
              <t-input v-model="resultChinese" placeholder="" disabled></t-input>
            </t-form-item>
            <!-- <t-button class="download" @click="downLoad" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button> -->
              <t-button class="download" @click="downLoadWord" :disabled="!formData.result"
              :loading="downLoading">查看计算过程和报告（消耗5积分）</t-button>
          </t-col>
        </t-row>

      </t-form>
    </div>

    <div class="calc-rules">
      <t-row>
        <t-col :span="6" style="border-right: 1px solid #DADDE1;">
          <h4><span>计算范围和计算公式</span></h4>
        </t-col>
        <t-col :span="6">
          <h4><span>费率标准</span></h4>
        </t-col>
      </t-row>
      <div class="calc-rules-value">
         <t-row style="height: auto; align-items: stretch;">
          <t-col :span="6" style="border-right: 1px solid #DADDE1;">
            <div class="calc-rules-value-left">
              <div class="title"><span>计算范围</span></div>
              <div class="info">{{ calculateRange }}</div>
              <div class="title" style="margin-top: 33px;"><span>计算公式</span></div>
              <div class="info" style="white-space: pre-line;" >{{ calculationFormula }}</div>
            </div>
          </t-col>
          <t-col :span="6" style="padding: 20px;overflow: auto;" class='rate-table'>
            <div class="calc-rules-value-right">
              <t-table bordered row-key="index" :data="data" :columns="columns" />
            </div>
          </t-col>
        </t-row>
      </div>
    </div>


    <t-dialog placement="center" :visible="visible1" :footer="false" :onConfirm="close1" :onClose="close1"
      class="dialog1">
      <span slot="header">
        环境影响评价费行业调整系数
        <div class="closeButton" @click="close1"></div>
      </span>


        <t-radio-group v-model="value1" @change="onChange1">
          <t-row>
            <t-col :span="12">
              <div style="width: 600px;margin: 0 auto;">
                <t-radio value="化工、冶金、有色、黄金、煤炭、矿产、纺织、化纤、轻工、医药、区域-1.2" style="float: left;">化工、冶金、有色、黄金、煤炭、矿产、纺织、化纤、轻工、医药、区域
              </t-radio> <span style="float: right;line-height: 40px;">1.2</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 600px;margin: 0 auto;"><t-radio value="石化、石油天然气、水利、水电、旅游-1.1" style="float: left;">石化、石油天然气、水利、水电、旅游 </t-radio><span style="float: right;line-height: 40px;">1.1</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 600px;margin: 0 auto;"><t-radio value="林业、畜牧、渔业、农业、交通、铁道、民航、管线运输、建材、市政、烟草、兵器-1.0" style="float: left;">林业、畜牧、渔业、农业、交通、铁道、民航、管线运输、建材、市政、烟草、兵器 </t-radio><span style="float: right;line-height: 40px;">1.0</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 600px;margin: 0 auto;"><t-radio value="邮电、广播电视、航空、机械、船舶、航天、电子、勘探、社会服务、火电-0.8" style="float: left;">邮电、广播电视、航空、机械、船舶、航天、电子、勘探、社会服务、火电 </t-radio><span style="float: right;line-height: 40px;"> 0.8</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 600px;margin: 0 auto;"><t-radio value="粮食、建筑、信息产业、仓储-0.6" style="float: left;">粮食、建筑、信息产业、仓储 </t-radio><span style="float: right;line-height: 40px;">0.6</span></div>
            </t-col>
          </t-row>
          
          
          
          
          
        </t-radio-group>

      
    </t-dialog>

    <t-dialog placement="center" :visible="visible2" :footer="false" :onConfirm="close2" :onClose="close2"
      class="dialog2">
      <span slot="header">
        环境敏感程度调整系数
        <div class="closeButton" @click="close2"></div>
      </span>
      <t-radio-group v-model="value2" @change="onChange2">
          <t-row>
            <t-col :span="12">
              <div style="width: 100px;margin: 0 auto;">
                <t-radio value="敏感-1.2" style="float: left;">敏感
              </t-radio> <span style="float: right;line-height: 40px;">1.2</span></div>
            </t-col>
            <t-col :span="12">
              <div style="width: 100px;margin: 0 auto;"><t-radio value="一般-0.8" style="float: left;">一般 </t-radio><span style="float: right;line-height: 40px;"> 0.8</span></div>
            </t-col>

          </t-row>
          
          
          
          
          
        </t-radio-group>
      

    </t-dialog>
    <file-view v-bind:visible.sync="visible" :fileUrl="openFileUrl" :downFileUrl="downFileUrl"></file-view>
  </div>
</template>

<script>
import { gethjyxpjf } from '@/api/data'
import { listRate } from "@/api/rate";
import { listFile } from "@/api/file";

export default {
  name: 'bzhjyxbgbFee',
  components: {

  },
  data() {
    return {
      jsgc: null,
      visible: false,
      downFileUrl:null,
      openFileUrl: null,
      downLoading: false,
      validateMessage: {
        projectName: [
          {
            type: 'error',
            message: '项目名称不能为空',
          },
        ],
        money: [
          {
            type: 'error',
            message: '请输入规范数字',
          },
        ]

      },
      rules: {
        projectName: [{ required: true }, { type: 'warning' }],
        money: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        industryCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
        circumstancesCoefficient: [{ required: true }, { pattern: /^[0-9.]*$/, message: '请输入规范数字', required: true, type: 'warning' }],
      },

      helpOpen: false,
      downData: {},
      value1: '',
      visible1: false,
      value2: '',
      visible2: false,
      discountRate: null,
      floatingRate: null,
      formData: {
        projectName: '',
        ificationId: this.$route.query.ification,
        money: null, //估算投资额
        subtotal: null, //环境影响评价费基价
        industryCoefficient: null, //行业调整系数
        circumstancesCoefficient: null, //环境敏感程度调整系数
        floatingRate: null,//浮动率
        standardPrice: null,//基准价
        discountRate: 0,
        discountRateMoney: null,
        result: null
      },
      
      resultChinese: '',
      fileList: [],
      data: [{
       
      }],
      columns: [
      {
          title: '序',
          colKey: 'id',
          width: 90,
        },
        {
          title: '估算投资额（亿元）',
          width: 100,
          colKey: '-',
          children: [
            {
              colKey: 'startValue',
              title: '起值',
              width: 100,
            },
            {
              title: '终止',
              colKey: 'finalValue',
              width: 100,
            }
          ],
        },
        {
          title: '收费范围值（万元）',
          width: 100,
          colKey: '-',
          children: [
            {
              title: '起止',
          colKey: 'rate',
          width: 100,
            },
            {
              title: '终止',
              colKey: 'remark',
              width: 100,
            }
          ],
          
        }


      ],
      complexitycolumns: [
        {
          title: '等级',
          colKey: 'name',
          width: 50,
        },
        {
          title: '工程特征',
          colKey: 'features',
          width: 180,
        }

      ],
      calculateRange:null,//计算范围
      calculationFormula:null // 计算公式

    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList(){
      listFile({ classificationId: this.$route.query.ification }).then(response => {
        // console.log(response)
        this.fileList = response.rows[0];
        console.log(this.fileList)

      });

    listRate({ ificationId: this.$route.query.ification}).then(res => {
      let i = 1
        res.rows.forEach((item) => {
          item.id = i++
          if (item.finalValue > 99999999){
            item.finalValue = ""
          }
          this.data.push(item)
        })
        this.data = res.rows
        
      });
      this.getClassification(this.$route.query.ification || 3).then(res => {
        if(res.data.scope){
          if (res.data.scope.indexOf("\\n")!=-1){
            this.calculateRange = res.data.scope.replaceAll('\\n', '\n')
          }else{
            this.calculateRange = res.data.scope
          }
          
        }else{
          this.calculateRange = '暂无数据'
        }
        if(res.data.particulars){
          if (res.data.particulars.indexOf("\\n")!=-1){
            this.calculationFormula = res.data.particulars.replaceAll('\\n', '\n')
          }else{
            this.calculationFormula = res.data.particulars
          }
        }else{
          this.calculationFormula = '暂无数据'
        }
      })
    },
    onReset() {
      this.$message.success('重置成功');
      console.log('formData', this.formData);
    },
    onSubmit({ validateResult, firstError }) {
      if (validateResult === true) {
        this.submit()
        this.$message.success('提交成功');
      } else {
        console.log('Errors: ', validateResult);
        this.$message.warning(firstError);
      }
    },
    handleClear() {
      this.helpOpen = true
    },

    submit() {

      this.formData.discountRate = Number(this.discountRate) / 100
      this.formData.floatingRate = Number(this.floatingRate) / 100
      gethjyxpjf(this.formData).then(res => {

        this.downData = res.data
        this.formData.money = res.data.money.toString()
        // this.formData.discountRateMoney = res.data.discountRateMoney.toFixed(2).toString()
        this.formData.result = res.data.result.toFixed(2).toString()
        this.formData.subtotal = res.data.subtotal.toFixed(2).toString()
        this.formData.standardPrice = res.data.standardPrice.toFixed(2).toString()

        // this.formData.money.toString()
        this.resultChinese = this.changeNumMoneyToChinese(Number(this.formData.result))
        // this.$message.success('提交成功');
        this.jsgc = res.data.jsgc

      })





    },
    downLoad() {
      this.downLoading = true
      this.download('/project/fee/excle', { id: this.downData.id, classId: 20 }
        , `设计服务费计算.xlsx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    downLoadWord(){
      this.downLoading = true;
      let wordParam = {
        xmmc:this.formData.projectName,
        xsz:'估算投资额' + this.formData.money + '（亿元）'+ `;专业调整:${this.formData.industryCoefficient};环境敏感程度调整:${this.formData.circumstancesCoefficient};浮动率:${this.floatingRate}%;让利利率：${this.discountRate}%。`,
        yjwj:this.fileList && this.fileList.fileName || '无文件' || '无文件',
        hytzxs:this.formData.industryCoefficient,
        mgcdtzxs:this.formData.circumstancesCoefficient,
        jsgc:this.jsgc,
        fulx:'编制环境影响报告表',
        zhj:this.formData.result,
      }
      this.download('/project/hjyxpj/word', { id: this.downData.id, classId: 34,...wordParam }
        , `环境影响评价费计算.docx`).then(res => {
          console.log(res)
          this.downLoading = false
        }
        )
    },
    resultChange(value) {
      this.resultChinese = this.changeNumMoneyToChinese(value)
    },
    openVisible1() {
      this.visible1 = true
    },
    close1() {
      this.visible1 = false;
    },
    onChange1(checkedValues) {
      // console.log('checkedValues:', this.value1, checkedValues.split('-').slice(-1));
      this.formData.industryCoefficient = checkedValues.split('-').slice(-1).toString()
    },
    openVisible2() {
      this.visible2 = true
    },
    close2() {
      this.visible2 = false;
    },
    onChange2(checkedValues) {
      // console.log('checkedValues:', this.value2, checkedValues.split('-').slice(-1));
      this.formData.circumstancesCoefficient = checkedValues.split('-').slice(-1).toString()
    },
    fileOpenDialog(url) {
      this.downFileUrl =  url
      let fileUrl = '/pdfjs/web/viewer.html?file=' + process.env.VUE_APP_BASE_API + url
      // window.open(fileUrl,'_blank')
      this.openFileUrl = fileUrl
      this.visible = true
    }
    // validateInput() {
    //   const value = this.formData.money;
    //   this.formData.money = value.replace(/[^0-9.]/g, ""); // 只保留数字和小数点
    // }
  },
  // directives: {
  //   digits: {
  //     bind(el) {
  //       el.addEventListener("input", function(e) {
  //         // console.log(e.data)


  //           const value = e.target.value;
  //           if (e.isComposing || value === "") return; // 避免拼音输入和空值导致删除内容
  //         e.target.value = value.replace(/[^0-9.]/g,''); // 只保留数字

  //       });
  //   }
  //   }
  // }
}
</script>

<style lang="less">
.hjyxpjf {
  background: #ffffff;
  width: 1168px;
  margin: 0 auto;
  border: 1px solid #e3e6ea;
  padding-bottom: 38px;


  

  

  

  .dialog1 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      min-width: 902px !important;
      // height: 720px !important;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      // padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;
        background: url('@/assets/dialog-background.png');

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 8px !important;
        }

        .t-radio__label {
          height: 40px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;
          line-height: 40px;

          span {
            color: #000000;
          }

        }

        .t-space {
          margin-bottom: 20px;
        }
      }
    }
  }

  .dialog2 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 600px;
      // height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;


      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        background: url('@/assets/dialog-background.png');

        padding: 0;

        .t-form__label {
          height: 32px;
          line-height: 32px;
          font-family: "Regular";
        }

        .custom-cascader-1 {
          width: 300px;
        }

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 40px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;
          line-height: 40px;

          span {
            color: #000000;
          }
        }

        .complexity-table {
          padding: 20px;
          background: url('@/assets/dialog-background.png');
        }
      }
    }
  }

  .dialog3 {
    .t-dialog__close {
      display: none;
    }

    .t-dialog {
      width: 902px;
      height: 200px;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #e3e6ea;
      padding: 0;
      padding-bottom: 32px;

      .t-dialog__header {
        height: 57px;
        opacity: 1;
        background: linear-gradient(180deg, #ffffff 0%, #fafafa 100%);
        border-bottom: 1px solid #f5f5f5;

        .t-dialog__header-content {
          display: block;
          margin-left: 24px;
          position: relative;
        }

        .closeButton {
          background: url('@/assets/icon/button_cleaner-3nosha.svg');
          width: 24px;
          height: 24px;
          content: "  ";
          float: right;
          right: 24px;
          position: relative;
          cursor: pointer;
        }
      }

      .t-dialog__body {
        padding: 0;

        p {
          height: 22px;
          opacity: 1;
          color: #0655de;
          font-size: 16px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: center;
          line-height: 22px;
          letter-spacing: -0.01px;
          margin-top: 20px;
          margin-bottom: 15px;
        }

        .t-radio__label {
          height: 22px;
          opacity: 1;
          color: #606266;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Medium';
          text-align: left;
          line-height: 22px;
          letter-spacing: -0.01px;

          span {
            color: #000000;
          }
        }
      }
    }
  }

}</style>

